export default __webpack_public_path__ + "static/media/Portrett-Sevan-tekstet-151220.e501691c.mp4";